import axios from 'axios';
import { constructServiceURL } from '../../../../core/modules/common/tools/URLTools';
import config from '../../../../core/config/configureSettings';

export const getOperatorUser = () => {
  const serviceURL = constructServiceURL({
    endpoint: 'getOperatorUser',
    stub: config.useStubbedEndpoints,
  });

  return axios.get(serviceURL);
};

export default getOperatorUser;
